// extracted by mini-css-extract-plugin
export default {"component":"AddSlot_component__ycies"};